import { t as __t } from "i18next";
import React from "react";

const InputNumberFormat = ({
    value,
    onChange,
    name,
    placeholder = __t("uiText.text015"),
    className = "",
    onBlur,
    maxLength = null,
    min = null,
    max = null,
    required,
    type = "text",
    disabled = false,
}) => {
    const formatNumber = (num) => {
        if (num === null || num === undefined || num === "") return "";
        return Number(num).toLocaleString("en-US");
    };

    const handleChange = (e) => {
        const rawValue = e.target.value;

        // ລຶບທຸກຢ່າງທີ່ບໍ່ແມ່ນຕົວເລກ
        const numericValue = rawValue.replace(/\D/g, "");

        onChange({
            target: {
                name,
                value: numericValue === "" ? "" : Number(numericValue),
            },
        });
    };

    return (
        <input
            onBlur={onBlur}
            maxLength={maxLength ? maxLength : 100000000000}
            min={min ? min : 0}
            max={max ? max : 100000000000}
            required={required}
            type={type}
            name={name}
            value={formatNumber(value)}
            onChange={handleChange}
            placeholder={placeholder}
            className={className}
            disabled={disabled}
        />
    );
};

export default InputNumberFormat;